import React from 'react';
import { BenefitCard } from '../../components/BenefitCard';
import { SELF_DEFENSE_BENEFITS } from './selfDefenseContent';
export function SelfDefenseBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2968">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2969">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2970">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2971">
            Why Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2972">
          {SELF_DEFENSE_BENEFITS.map((benefit, idx) => <BenefitCard key={idx} icon={benefit.icon} title={benefit.title} description={benefit.description} data-id="element-2973" />)}
        </div>
      </div>
    </section>;
}